import * as Yup from "yup";

export const addressSchema = {
  address_search: Yup.string().when(["address_line_1", "city", "state", "zip_code"], {
    is: (address_line_1: string, city: string, state: string, zip_code: string) => {
      return !address_line_1 && !city && !state && !zip_code;
    },
    then: (schema) => schema.required("Please enter a valid address"),
    otherwise: (schema) => schema.optional(),
  }),
  address_line_1: Yup.string()
    .required("Address line 1 is required")
    .max(100, "Address line 1 must be less than 100 characters")
    .test("not-just-city-state", "Please provide a more specific address", function (value) {
      if (!value) {
        return false;
      }
      const { city, state } = this.parent;
      if (value === city || value === state) {
        return false;
      }
      return true;
    }),
  address_line_2: Yup.string().optional().max(100, "Address line 2 must be less than 100 characters"),
  city: Yup.string().required("City is required").max(50, "City name must be less than 50 characters"),
  state: Yup.string().when("country_code", {
    is: (country_code: string) => country_code === "US" || country_code === "AU",
    then: (schema) => schema.required("State is required"),
    otherwise: (schema) => schema.optional(),
  }),
  country_code: Yup.string().required("Country is required"),
  zip_code: Yup.string()
    .required("Zip code is required")
    .test("zip-code-format", function (value) {
      if (!value) {
        return true;
      }
      const { country_code } = this.parent;
      if (country_code === "US") {
        if (!/^\d{5}(-\d{4})?$/.test(value)) {
          return this.createError({ message: "Invalid zip code format, e.g. 12345 or 12345-6789" });
        }
      } else if (country_code === "GB") {
        if (!/^[A-Z]{1,2}\d[A-Z\d]? \d[A-Z]{2}$/i.test(value)) {
          return this.createError({ message: "Invalid zip code format, e.g. SW1A 1AA or M1 1AA" });
        }
      } else if (country_code === "AU") {
        if (!/^\d{4}$/.test(value)) {
          return this.createError({ message: "Invalid zip code format, e.g. 2000" });
        }
      }
      return true;
    }),
};
